import {Grid, Stack, Typography, useTheme} from '@mui/material';
import {ResourceTile} from 'components/ResourceTile/ResourceTile';
import TileData from './ResourceGridData.json';
import {useSelector} from 'react-redux';
import {selectUserType} from 'app/store/users/userSlice';
import {LogInType} from 'app/types/Shared';
import {useNavigate} from 'react-router-dom';

export enum ResourceTileTypes {
  Link = 'link',
  Page = 'page',
}

type ResourceTile = {
  title: string;
  link?: string;
  type: string;
  restricted?: boolean;
};

const ResourceGrid = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const userType = useSelector(selectUserType);

  const handleTileClick = (type: string, link?: string) => {
    if (type === ResourceTileTypes.Link && link) {
      window.open(link, '_blank');
    } else {
      console.log('Navigating to:', `/resources${link}`);
      navigate(`/resources${link}`);
    }
  };

  return (
    <Stack px={6} paddingBottom='20px'>
      {TileData.map((sections, index) => (
        <Stack
          key={sections.section}
          borderBottom={index !== TileData?.length - 1 ? `1px solid ${theme.palette.grey[500]}` : 'none'}
          paddingBottom='20px'
        >
          <Typography variant='h5' py='20px'>
            {sections.section}
          </Typography>
          <Grid container direction='row' columnSpacing='20px' rowGap='20px'>
            {sections?.tiles
              .filter((tile: ResourceTile) => userType === LogInType.Internal || !tile?.restricted)
              .map((tile) => (
                <Grid item xs='auto' key={tile.title}>
                  <ResourceTile title={tile.title} link={tile.link} type={tile.type} onTileClick={handleTileClick} />
                </Grid>
              ))}
          </Grid>
        </Stack>
      ))}
    </Stack>
  );
};

export default ResourceGrid;
